// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TemplateDetails_wrap__i65HJ {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.TemplateDetails_icons__yulrn {
  float: right;
}

.TemplateDetails_detailsIcon__WdVCE {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Templates/components/TemplateDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.icons {\n  float: right;\n}\n\n.detailsIcon {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `TemplateDetails_wrap__i65HJ`,
	"icons": `TemplateDetails_icons__yulrn`,
	"detailsIcon": `TemplateDetails_detailsIcon__WdVCE`
};
export default ___CSS_LOADER_EXPORT___;
